@if (!icon() && !svgIcon()) {
    <p-tag
        [severity]="$any(severity() || 'primary')"
        [rounded]="rounded()"
    >
        <ng-container *ngTemplateOutlet="addressTemplate"></ng-container>
    </p-tag>
} @else {
    <p-tag
        [severity]="$any(severity() || 'primary')"
        [rounded]="rounded()"
    >
        <div class="flex gap-small align-items-center">
            <app-icon class="flex" [icon]="icon() || svgIcon()"></app-icon>
            <ng-container *ngTemplateOutlet="addressTemplate"></ng-container>
        </div>
    </p-tag>
}

<ng-template #addressTemplate>
    <app-map-link
        [format]="MapLinkFormatEnum.SingleLine"
        [data]="address()"
    ></app-map-link>
</ng-template>
